__turbopack_context__.v({
  "col": "DoubleCardWide-module-scss-module__aNonoW__col",
  "container": "DoubleCardWide-module-scss-module__aNonoW__container",
  "wrapper": "DoubleCardWide-module-scss-module__aNonoW__wrapper",
});
